(() => {
  /**
   * @ngdoc directive
   * @name kareo.ui.shared.assets:kStarRating
   * @restrict E
   * @scope
   * @description
   * Displays a selector for star ratings/amounts. As a note,
   * this is a component rather than a directive, but components are unsupported by this version
   * of ngDoc.
   *
   * @param {number} ratingValue Number of stars currently selected
   * @param {number} maxValue Highest selectable number of stars
   * @param {boolean} enabled Whether or not the component is active

   * @example
   <example module="kareo.ui.shared.directives.k-star-rating">
   <file name="index.html">
   <div ng-controller="kStarRating">

   <k-star-rating rating-value="1" enabled="true" max-value="5" on-rating-changed="logRating(rating)">
   </k-star-rating>
   <label> Choose your value or something</label>

   </div>
   </file>
   <file name="demo.js">
     var app = angular.module('kareo.ui.shared.directives.k-star-rating');

     app.controller('kStarRating', ['$scope', function($scope){
       $scope.ratingValue = 1;
       $scope.maxValue = 5;
       $scope.enabled = true;
       $scope.logRating = function (rating) {
          console.log('rating changed: ', rating);
       };
     }]);

   </file>
   </example>
   */

  angular
  .module('kareo.ui.shared.directives.k-star-rating', [
  ])
  .component('kStarRating', {
    controller,
    controllerAs: 'vm',
    bindings: {
      ratingValue: '<',
      maxValue: '<',
      onRatingChanged: '&',
      enabled: '<'
    },
    template: require('./k-star-rating.pug')()
  });

  controller.$inject = ['$scope'];

  function controller($scope) {
    let vm = this;
    vm.toggle = toggle;
    vm.maxValue = vm.maxValue || 5;

    $scope.$watch('vm.ratingValue', updateStars);

    function toggle(value) {
      if (vm.ratingValue !== value) {
        vm.ratingValue = value;
        vm.onRatingChanged({ rating: value });
      }
    }

    function updateStars() {
      vm.stars = [];
      for (let i = 0; i < vm.maxValue; i++) {
        vm.stars.push({
          filled: i < vm.ratingValue,
          value: i + 1
        });
      }
    }
  }
})();
